import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'

function ModalCancelarMdfe({ mdfe, isVisible, onCancel, onSave, onError }) {
  // Hooks
  const [justificativa, setJustificativa] = useState('')

  useEffect(() => {
    if (isVisible) setJustificativa(mdfe && mdfe.justificativa ? mdfe.justificativa : '')
  }, [isVisible, mdfe])

  if (!mdfe) return null

  // Events
  const onBtnSalvarClicked = async () => {
    const justificativaLimpa = justificativa.trim()
    if (justificativaLimpa.length < 15) {
      onError('A justificativa deve conter pelo menos 15 caracteres')
      return
    }
    if (justificativaLimpa.length > 255) {
      onError('A justificativa deve conter no máximo 255 caracteres')
      return
    }
    onSave({ ...mdfe, justificativa: justificativaLimpa })
  }

  // Render
  return (
    <CustomModal header="Cancelar Mdfe" isVisible={isVisible} onClose={onCancel}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Justificativa (entre 15 e 255 caracteres):"
            marginTop={10}
            value={justificativa}
            onChange={value => setJustificativa(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalCancelarMdfe
